import { twoDigits } from '@nx-smartmonkey/shared/helpers';
import { useEffect, useState } from 'react';
import { Text } from '../../../../../react-components/Text';

interface CounterTimeTextProps {
  counter: number;
}

export const CounterTimeText = ({ counter }: CounterTimeTextProps) => {
  const [currentCounter, setCurrentCounter] = useState(counter);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCounter((prevCounter) => prevCounter + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Text style={{ marginLeft: `4px`, marginTop: `1px`, whiteSpace: `nowrap` }}>
      {Math.floor(currentCounter / 60) > 60
        ? `${twoDigits(Math.floor(currentCounter / 3600))}h ${twoDigits(currentCounter / 60)}m`
        : `${twoDigits(Math.floor(currentCounter / 60))}m ${twoDigits(currentCounter % 60)}s`}
    </Text>
  );
};
